import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "../components/auth/login/login.component";
import { AuthenticatorComponent } from "../components/auth/authenticator/authenticator.component";
import { ForgotPasswordComponent } from "../components/auth/forgot-password/forgot-password.component";
import { ActivationCodeComponent } from "../components/auth/activation-code/activation-code.component";
import { MfaLoginComponent } from "../components/auth/mfa-login/mfa-login.component";
import { MfaTranactionComponent } from "../components/auth/mfa-tranaction/mfa-tranaction.component";
import { ChangePasswordComponent } from "../components/auth/change-password/change-password.component";
import { ActivationComponent } from "../components/auth/activation/activation.component";
import { ResetPasswordComponent } from "../components/auth/reset-password/reset-password.component";
import { ProceedResetPwdComponent } from "../components/auth/proceed-reset-pwd/proceed-reset-pwd.component";

const routes: Routes = [
  //{ path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'logOut', component: LoginComponent },
  { path: 'authentication', component: AuthenticatorComponent },
  { path: 'forgot_password/:userID', component: ForgotPasswordComponent },
  { path: 'forgot_password', component: ForgotPasswordComponent },
  { path: 'useractivate/:id', component: ActivationCodeComponent },
  { path: 'mfa-login', component:MfaLoginComponent},
  { path: 'mfa-transactions', component:MfaTranactionComponent},
  { path: 'change_password', component:ChangePasswordComponent},
  { path: 'change_transaction_password', component:ChangePasswordComponent},
  { path: 'user-block/:userID', component: ActivationComponent },
  { path: 'user-deactivate/:userID', component: ActivationComponent },
  { path: 'user-unblock/:userID', component: ActivationComponent },
  { path: 'user-unlock/:userID', component: ActivationComponent },
  { path: 'edit-mfa-login', component:MfaLoginComponent},
  { path: 'edit-mfa-transactions', component:MfaTranactionComponent},
  { path: 'reset-password/:uniqueCode', component:ResetPasswordComponent},
  { path: 'email-otp/:uniqueCode', component:ResetPasswordComponent},
  { path: 'user-pwd-reset/:uniqueCode', component:ProceedResetPwdComponent},
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
